import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { ConfirmationModalConfig, ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { CONFIRMATION_MODAL_DATA } from '@core/customCDK/cdkCustomMdl/tokens/confirmation-data.token';
import { FileUploadService } from '@core/services/file-upload.service';
import { ShowErrorsComponent } from '@core/show-errors/show-errors.component';
import { CategoryService } from '../category/helper/category.service';
import { ControlInfra } from '@page/connect-bank-account/helper/connect-bank-types';
import { TicketingService } from '../helper/ticketing.service';
import { ConfirmationModalData } from '@core/customCDK/cdkCustomMdl/interfaces/confirmation-modal-data';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { FileExtensionPipe } from '@core/pipes/fileExtention.pipe';
import { SwitchCasesDirective } from '@core/directives/SwitchCases.directive';
import { FileimagepreviewComponent } from '@core/fileimagepreview/fileimagepreview.component';

@Component({
  selector: 'app-universal-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ShowErrorsComponent,
    FileExtensionPipe,
    // SwitchCasesDirective,
    FileimagepreviewComponent
  ],
  providers: [FileUploadService],
  templateUrl: './universal-form.component.html',
  styleUrl: './universal-form.component.scss'
})
export class UniversalFormComponent implements OnInit {
  dynamicFiledList: ControlInfra[] | null = [];
  maxSize = 5 * 1024 * 1024; // 5MB in bytes
  form: FormGroup;
  fileData:any;
  constructor(
    public dialogRef: ConfirmationModalOverlayRef,
    @Inject(CONFIRMATION_MODAL_DATA) public data: any,
    private _ChangeDetectorRef: ChangeDetectorRef,
    private _FileUploadService: FileUploadService,
    private _ConfirmationModalService: ConfirmationModalService,
    private fb: FormBuilder,
    private _CategoryService: CategoryService,
    private _TicketingService: TicketingService,
    private _Router: Router,
  ) {
    this.dynamicFiledList = data?.data;
    this.form = this.fb.group({});
    this.populateDynamicForm();
  }
  ngOnInit(): void {
  }

  private populateDynamicForm(): void {
    this.dynamicFiledList?.forEach((field: any) => {
      const validation = [];
      if (field.required === 'Y') {
        validation.push(Validators.required);
      }
      this.form.addControl(field.fieldname, this.fb.control('', validation));
    });
  }

  // getControl(parent: FormGroup | FormArray, i: number, child?: string): FormGroup | FormControl {

  //   const control = (parent as FormArray).at(i) as FormGroup;
  //   if (child) {
  //     return control.get(child) as FormControl;
  //   }
  //   return control;
  // }

  // checkValidation(parent: FormGroup | FormArray, i: number, child?: string) {
  //   if (!this.getControl(parent, i, child).value) {
  //     this.getControl(parent, i, child).markAsTouched();
  //   }
  // }
  // redirectionfn(){
  //   this.Router.navigate(['/managecomplaint/trackcomplaint/transaction-complaints'])
  //   this.dialogRef.close();
  // }
  // ngAfterViewInit() {
  //   document.addEventListener('click', (event) => {
  //     const target = event.target as HTMLElement;
  //     if (target.classList.contains('support-link') || target.closest('.support-link')) {
  //       event.preventDefault();
  //       this.redirectionfn();

  //     }
  //   });
  // }
  
 routeTrack(data:any){
  const supportTypeId = this._TicketingService.raiseTicketData?.support_type_id;

switch (supportTypeId) {
  case 1:
    this._Router.navigate(['/managecomplaint/trackcomplaint/general-complaints'],{
      state: {
        ticketId: data
      }
    });
    break;
  case 2:
    this._Router.navigate(['/managecomplaint/trackcomplaint/transaction-complaints'],{
      state: {
        ticketId: data,
      }
    });
    break;
}
 }
  onSubmit() {
    this._TicketingService.updateRaiseTicketData = {
      attachment_name: this.fileData?.name,
      attachment_size: this.fileData?.size
    };
    if (this.form.valid) {
      this._TicketingService.raiseTicket(this.form.value).subscribe((res: any) => {
        let data: ConfirmationModalData = {
          icon: res.code == 200 ? 'success' : 'error',
          msg: res.message,
          // btnConfirm: 'Okay',
          btnClose: 'Done',

        }
        if (res.code == 200) {
          this.dialogRef.close();
          data = {
            ...data,
            title: `We have received your query`,
            subtext: `
           <p>your ticket number is ${res.ticket_id}</p>
            <p>You can view your query and track its status in</p>
            <p><a class="support-link"><u><b>Support Tickets Inbox</b></u></a></p>
            `,
            msg: `
            <p>an confirmations has been sent to</p>
            <b>${res.email}</b>
            <p>our support tram will send you an update within  8 working hours</p>
            `
          }
        }

        const customConfig: ConfirmationModalConfig = {
          data: {
            ...data
          }
        };
        const { ref, events$ } = this._ConfirmationModalService.init2(ConfirmationComponent, customConfig);

        events$.subscribe((event) => {
          console.log(event);
          event.initRef.close();
          // handle event
        });

        // later
   

        // this._ConfirmationModalService.init2(ConfirmationComponent, customConfig).pipe(tap((t) => {
        //   console.log(t);

        // })).subscribe((events: any) => {
        //   events.initRef.close();
        // });
        document.addEventListener('click', (event) => {
          const target = event.target as HTMLElement;
          // Check if the click was on a support link
          if (target.classList.contains('support-link') || target.closest('.support-link')) {
            event.preventDefault();
            ref.close();
            // Handle redirection directly here
           this.routeTrack(res.ticket_id);
          }
        });
      })
    }
  }
  onFileSelect(event: any, fieldname: string) {
    const selectedFile: File = (event.target as HTMLInputElement).files![0];
    
    console.log(selectedFile)
    this._TicketingService.calculateFileSize(selectedFile)
    this._TicketingService.$fileDetails.subscribe((data:any)=>{
      this.fileData=data;
     })
    if (!selectedFile) {
      this.form.get(fieldname)?.setErrors({ fileError: 'No file selected' });
      return;
    }

    // Validate file size
    if (selectedFile.size > this.maxSize) {
      this.form.get(fieldname)?.setErrors({ fileError: 'File size exceeds the maximum limit of 5MB' });
      return;
    }

    // Validate file type (optional, based on `accept` attribute)
    // const allowedTypes = this.dynamicFiledList.find((field: any) => field.fieldname === fieldname)?.accept_fileupload;
    // if (allowedTypes && !allowedTypes.split(',').includes(selectedFile.type)) {
    //   this.form.get(fieldname)?.setErrors({ fileError: 'Invalid file type' });
    //   return;
    // }

    // If validation passes, upload the file
    const formData = new FormData();
    formData.append('file', selectedFile);

    this._FileUploadService.upload(formData).subscribe(
      (response: any) => {
        if (response.code === 200) {
          this.form.get(fieldname)?.setValue(response.data.path);
          this.form.get(fieldname)?.setErrors(null);
          this._ChangeDetectorRef.detectChanges();
        } else {
          this.form.get(fieldname)?.setErrors({ fileError: response.message });
        }
      },
      (error) => {
        this.form.get(fieldname)?.setErrors({ fileError: 'File upload failed. Please try again.' });
      }
    );
  }


  back() {
    this.dialogRef.close();
    this._CategoryService.fetchRequestType();
  }
  clear(fieldName:any){
    this.form.get(fieldName)?.reset()
    this.fileData=''
  }
}